
import TMModel from "@/modules/tm/api/tm/tm-model";
import TMDefines from "@/modules/tm/defines/tm-defines";
import React from "react";
import styles from "./index.module.scss";

export interface ITMDetailBasicInfoProps {
  model: TMModel;
}

const TMDetailBasicInfo: React.FC<ITMDetailBasicInfoProps> = (props) => {
  let model = props.model;
  let extend = model.extend;

  return (
    <div className={styles.container}>
      <div className={`${styles.header} flex-row flex-cross-axis-center`}>
        <h2>基本信息</h2>
      </div>
      <hr />
      <div className={styles.content}>
        <div className="flex-row">
          <div className={styles.item}>
            <span className={styles.title}>初审公告期号：</span>
            <span className={styles.value}>{extend.announcementIssue}</span>
          </div>
          <div className={styles.item}>
            <span className={styles.title}>初审公告日期：</span>
            <span className={styles.value}>{extend.announcementDate}</span>
          </div>
          <div className={styles.item}>
            <span className={styles.title}>组合类型：</span>
            <span className={styles.value}>
              {TMDefines.GetTMRegTypeValue(model.type)}
            </span>
          </div>
          <div className={styles.item}>
            <span className={styles.title}>有效期限：</span>
            <span
              className={styles.value}
            >{`${extend.privateStartDate} 至 ${extend.privateEndDate}`}</span>
          </div>
        </div>
        <div className="flex-row" style={{ marginTop: 20 }}>
          <div className={styles.item}>
            <span className={styles.title}>注册公告期号：</span>
            <span className={styles.value}>{extend.registerIssue}</span>
          </div>
          <div className={styles.item}>
            <span className={styles.title}>注册公告日期：</span>
            <span className={styles.value}>{extend.registerDate}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TMDetailBasicInfo;
